import React, { useState, useEffect, useCallback } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import GetDistinctCategories from "../../../utils/database/GetDistinctCategories";
import GetDistinctSubcategories from "../../../utils/database/GetDinctinctSubcategories";
import "./PublicationsFilter.css";
import Loader from "../../general/Loader";

const PublicationsFilter = ({ onFilterChange, searchValue, onSearchChange }) => {
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("all");
    const [selectedSubCategory, setSelectedSubCategory] = useState("all");
    const [loadingCategories, setLoadingCategories] = useState(true);
    const [loadingSubCategories, setLoadingSubCategories] = useState(false);

    useEffect(() => {
        const fetchCategories = async () => {
            setLoadingCategories(true);
            try {
                const fetchedCategories = await GetDistinctCategories();
                const formattedCategories = [
                    { label: "All Category", value: "all" },
                    ...fetchedCategories.map((cat) => ({ label: cat, value: cat })),
                ];
                setCategories(formattedCategories);
            } catch (error) {
                console.error("Error fetching categories:", error);
            } finally {
                setLoadingCategories(false);
            }
        };
        fetchCategories();
    }, []);

    useEffect(() => {
        const fetchSubCategories = async () => {
            if (selectedCategory && selectedCategory !== "all") {
                setLoadingSubCategories(true);
                try {
                    const fetchedSubCategories = await GetDistinctSubcategories(selectedCategory);
                    const formattedSubCategories = [
                        { label: "All Sub Category", value: "all" },
                        ...fetchedSubCategories.map((subcat) => ({ label: subcat, value: subcat })),
                    ];
                    setSubCategories(formattedSubCategories);
                } catch (error) {
                    console.error("Error fetching subcategories:", error);
                } finally {
                    setLoadingSubCategories(false);
                }
            } else {
                setSubCategories([{ label: "All Sub Category", value: "all" }]);
                setSelectedSubCategory("all");
            }
        };
        fetchSubCategories();
    }, [selectedCategory]);

    useEffect(() => {
        onFilterChange({ category: selectedCategory, subCategory: selectedSubCategory });
    }, [selectedCategory, selectedSubCategory, onFilterChange]);

    const handleCategoryChange = useCallback((e) => {
        setSelectedCategory(e.value);
        setSelectedSubCategory("all");
    }, []);

    const handleSubCategoryChange = useCallback((e) => setSelectedSubCategory(e.value), []);

    return (
        <div className="publications-filter">
        {loadingCategories || loadingSubCategories ? (
            <Loader />
        ) : (
            <>
                <div className="filter-group">
                    <label htmlFor="category">Category</label>
                    <Dropdown
                        id="category"
                        value={selectedCategory}
                        options={categories}
                        onChange={handleCategoryChange}
                        placeholder="Select a Category"
                        className="p-dropdown"
                    />
                </div>
                <div className="filter-group">
                    <label htmlFor="subcategory">Sub-Category</label>
                    <Dropdown
                        id="subcategory"
                        value={selectedSubCategory}
                        options={subCategories}
                        onChange={handleSubCategoryChange}
                        placeholder="Select a Sub-Category"
                        className="p-dropdown"
                        disabled={subCategories.length <= 1}
                    />
                </div>
                <div className="filter-group">
                    <label htmlFor="search">Search Publications</label>
                    <InputText
                        id="search"
                        value={searchValue}
                        onChange={(e) => onSearchChange(e.target.value)}
                        placeholder="Search publications..."
                        className="p-inputtext"
                    />
                </div>
            </>
        )}
    </div>
    );
};

export default PublicationsFilter;
